import axios from 'axios';
import {api} from '../../constants/api';

export const saveTaxAuthorityRow = ({
                                      shumaId,
                                      salePrice,
                                      estimatePrice,
                                      originSource,
                                      ...rest
                                    }) => dispatch => {
  const data = {
    shumaID: parseInt(shumaId, 10),
    salePrice: salePrice ? Number(salePrice.replace(/,/g, '')) : '',
    estimatePrice: estimatePrice ? Number(estimatePrice.replace(/,/g, '')) : '',
    oldId: originSource,
    ...rest
  };

  return axios.post(api.SAVE_ROW_TAX_AUTHORITY, data);
};

export const saveFirmRow = ({shumaId, selectedShumaID, ...rest}) => dispatch => {
  const data = {
    shumaID: parseInt(shumaId, 10),
    oldId: selectedShumaID,
    selectedShumaID,
    ...rest
  };

  return axios.post(api.SAVE_ROW_FIRM, data);
};

export const saveSharedRow = ({shumaId, selectedShumaID, ...rest}) => dispatch => {
  const data = {
    shumaID: parseInt(shumaId, 10),
    oldId: selectedShumaID,
    selectedShumaID,
    ...rest
  };

  return axios.post(api.SAVE_ROW_SHARED, data);
};

export const saveSurveyAssetsRow = ({
                                      shumaId,
                                      cityID,
                                      streetID,
                                      houseNum,
                                      houseRegisteredArea,
                                      houseRoomCount,
                                      floor,
                                      buildingFloorsCount,
                                      buildYear,
                                      houseParking,
                                      buildingElevator,
                                      houseYard,
                                      houseStorage,
                                      houseRoof,
                                      houseBalconyCount,
                                      askingPrice,
                                      marketingFactor,
                                    }) => dispatch => {
  const data = {
    shumaID: parseInt(shumaId, 10),
    cityID,
    streetID,
    houseNum,
    houseRegisteredArea: parseFloat(houseRegisteredArea),
    houseRoomCount: parseFloat(houseRoomCount),
    floor: parseInt(floor, 10),
    buildingFloorsCount: parseInt(buildingFloorsCount, 10),
    buildYear: parseInt(buildYear, 10),
    houseParking: parseInt(houseParking),
    buildingElevator: parseInt(buildingElevator),
    houseYard: parseInt(houseYard),
    houseStorage: parseInt(houseStorage),
    houseRoof: parseInt(houseRoof),
    houseBalconyCount: parseInt(houseBalconyCount, 10),
    askingPrice: parseFloat(askingPrice),
    marketingFactor,
  };

  return axios.post(api.SAVE_ROW_SURVEY_ASSETS, data);
};